<template>
  <v-autocomplete
    @input="setEmailCampaigns"
    :items="emailCampaigns"
    item-text="name"
    item-value="id"
    multiple
    chips
    :value="value"
    :label="label"
    :error-messages="errorMessages"
    :disable="disabled"
    no-data-text="No Campaigns for this Dealer"
  >
   <template v-slot:selection="data">
       <v-chip
         v-bind="data.attrs"
         :input-value="data.selected"
         close
         @click="data.select"
         @click:close="removeSelectedCampaign(data.item)"
       >
        {{ data.item.name }}
       </v-chip>
   </template>
   <template v-slot:prepend-item>
        <v-list-item
          ripple
          @click="toggleSelected"
        >
          <v-list-item-action>
            <v-icon :color="emailCampaigns.length > 0 ? 'indigo darken-4' : ''">{{ selectIcon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Select All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
  </v-autocomplete>
</template>

<script>
import { EmailCampaignApi } from '@/services'

export default {
  name: 'email-campaign-multiselect',
  props: {
    value: {
      type: Array,
      required: true
    },
    dealer_id: {
      type: [Number, String],
      required: false,
      default: null
    },
    errorMessages: {
      type: Array
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'Select email campaign(s)'
    }
  },
  data: function () {
    return {
      emailCampaigns: []
    }
  },
  computed: {
    selectIcon () {
      if (this.value.length === this.emailCampaigns.length) return 'mdi-close-box'
      if (this.value.length > 0 && this.value.length < this.emailCampaigns.length) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  watch: {
    dealer_id: function (newDealerId, oldDealerId) {
      if (newDealerId === oldDealerId) {
        return
      }

      // We only want to execute if the dealer_id changed from some val to some other val
      // don't execute the first time dealer_id is set, i.e. oldDealerId is null
      if (newDealerId && oldDealerId) {
        this.setEmailCampaigns([])
        this.fetchEmailCampaigns()
      }
    }
  },
  mounted: function () {
    this.fetchEmailCampaigns()
  },
  methods: {
    setEmailCampaigns: function (selectedEmailCampaigns) {
      this.$emit('input', selectedEmailCampaigns)
    },
    fetchEmailCampaigns: function () {
      return EmailCampaignApi.fetchEmailCampaignsAbbreviated(this.dealer_id)
        .then(resp => {
          this.emailCampaigns = resp.data
        })
        .catch(error => {
          this.$logger.error('Error Fetching EmailCampaigns by dealer', error.message)
          this.$flash({
            showClose: true,
            message: `Error fetching EmailCampaigns by dealer. ${error.message}`,
            type: 'error',
            duration: 0
          })
        })
    },
    toggleSelected () {
      this.$nextTick(() => {
        if (this.value.length > 0) {
          this.$emit('input', [])
        } else {
          this.$emit('input', this.emailCampaigns.map(c => c.id))
        }
      })
    },
    removeSelectedCampaign (item) {
      this.$nextTick(() => {
        this.$emit('input', this.value.filter(id => id !== item.id))
      })
    }
  }
}
</script>
